import { useQuery } from "@tanstack/react-query";

interface OrinAdminWhoami {
  is_admin: boolean;
  email: string;
  display_name: string | null;
}

export function useOrinAdmin() {
  const { data, isLoading } = useQuery<OrinAdminWhoami>({
    queryKey: ["orin-admin", "whoami"],
    queryFn: async () => {
      const res = await fetch("/api/orin-admin/whoami", { credentials: "include" });
      if (!res.ok) return { is_admin: false, email: "", display_name: null };
      return res.json();
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  return {
    isOrinAdmin: !!data?.is_admin,
    displayName: data?.display_name ?? null,
    isLoading,
  };
}
